<template>
  <svg
    width="256"
    height="256"
    viewBox="0 0 256 256"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M236.858 201.408L223.298 191.341C222.871 184.646 220.496 178.118 216.155 172.454C214.833 170.733 212.069 170.195 211.769 169.837C209.305 166.867 205.908 172.346 203.297 178.042C202.263 177.997 201.229 178.189 200.271 178.579L199.799 166.938H154.983L135.562 198.707L156.483 216.454C164.182 224.57 171.568 229.146 178.738 230.688C183.532 231.718 188.914 231.45 194.028 230.253L207.932 240.576C211.143 242.957 215.676 242.285 218.051 239.066L238.371 211.552C240.746 208.333 240.076 203.789 236.864 201.408H236.858Z"
      class="fill-brand-100"
    />
    <path
      d="M134.35 62.0352H200.757C200.757 62.0352 200.769 62.0544 200.776 62.0608C204.153 56.32 206.094 49.6256 206.094 42.4768C206.094 21.1392 188.838 3.84 167.553 3.84C146.269 3.84 129.013 21.1392 129.013 42.4768C129.013 49.6256 130.96 56.3136 134.331 62.0608C134.331 62.0544 134.343 62.0416 134.35 62.0352Z"
      class="fill-brand-300"
    />
    <path
      d="M163.761 236.973L126.778 136.922H208.315L171.333 236.973C170.03 240.499 165.057 240.499 163.755 236.973H163.761Z"
      class="fill-secondary-500"
    />
    <path
      d="M205.883 21.7408H194.634C192.42 21.7408 190.625 23.5402 190.625 25.76V33.9712C190.625 36.1909 192.42 37.9904 194.634 37.9904H205.883C208.097 37.9904 209.892 36.1909 209.892 33.9712V25.76C209.892 23.5402 208.097 21.7408 205.883 21.7408Z"
      class="fill-brand-100"
    />
    <path
      d="M142.177 23.6096C147.049 23.6096 150.999 19.6496 150.999 14.7648C150.999 9.87993 147.049 5.91998 142.177 5.91998C137.304 5.91998 133.354 9.87993 133.354 14.7648C133.354 19.6496 137.304 23.6096 142.177 23.6096Z"
      class="fill-brand-100"
    />
    <path
      d="M134.337 101.216H200.763C200.763 101.216 200.763 101.216 200.763 101.222C204.14 95.4816 206.081 88.7872 206.081 81.6384C206.081 74.4896 204.134 67.776 200.744 62.0288H134.337C130.954 67.776 129 74.4768 129 81.6384C129 88.8 130.947 95.4752 134.318 101.216C134.318 101.216 134.318 101.216 134.318 101.21L134.337 101.216Z"
      class="fill-brand-500"
    />
    <path
      d="M185.001 70.5344C191.259 70.5344 196.332 65.4483 196.332 59.1744C196.332 52.9004 191.259 47.8144 185.001 47.8144C178.742 47.8144 173.669 52.9004 173.669 59.1744C173.669 65.4483 178.742 70.5344 185.001 70.5344Z"
      class="fill-secondary-500"
    />
    <path
      d="M144.299 55.7105L144.294 55.715C141.771 58.2444 141.771 62.3452 144.294 64.8746L158.501 79.1163C161.024 81.6456 165.114 81.6456 167.637 79.1163L167.642 79.1118C170.165 76.5824 170.165 72.4815 167.642 69.9522L153.436 55.7105C150.913 53.1811 146.822 53.1811 144.299 55.7105Z"
      class="fill-brand-300"
    />
    <path
      d="M172.156 13.9836L145.765 31.6751C143.827 32.9738 143.307 35.6011 144.602 37.5432L147.782 42.3101C149.078 44.2523 151.698 44.7739 153.636 43.4752L180.027 25.7837C181.964 24.485 182.484 21.8578 181.189 19.9156L178.009 15.1487C176.714 13.2065 174.093 12.6849 172.156 13.9836Z"
      class="fill-secondary-500"
    />
    <path
      d="M149.831 187.021L148.503 186.406C149.103 185.728 149.614 184.96 150.016 184.096C152.2 179.36 150.144 173.747 145.42 171.558L142.834 170.362C143.37 169.728 143.836 169.018 144.2 168.23C146.384 163.494 144.328 157.882 139.604 155.693L135.92 153.984C131.196 151.795 125.597 153.856 123.414 158.592C121.231 163.328 123.286 168.941 128.01 171.13L130.596 172.326C130.06 172.96 129.594 173.67 129.23 174.458C127.046 179.194 129.102 184.806 133.826 186.995L135.793 187.91C135.352 188.461 134.956 189.069 134.65 189.741C132.6 194.182 134.535 199.443 138.959 201.498L142.413 203.098C146.843 205.152 152.091 203.213 154.14 198.778C156.19 194.336 154.262 189.075 149.831 187.021Z"
      class="fill-brand-100"
    />
    <path
      d="M195.513 236.381L229.178 190.805L245.862 203.191C248.412 205.084 248.95 208.701 247.062 211.257L220.243 247.564C218.355 250.12 214.748 250.659 212.198 248.766L195.513 236.381Z"
      class="fill-brand-300"
    />
    <path
      d="M194.592 145.334C191.342 141.246 185.401 140.574 181.324 143.832C177.246 147.091 176.575 153.046 179.826 157.134L201.526 184.424C204.776 188.512 210.717 189.184 214.794 185.925C218.872 182.667 219.542 176.711 216.292 172.623L194.592 145.334Z"
      class="fill-brand-100"
    />
    <path
      d="M119.424 201.408L105.864 191.341C105.436 184.646 103.061 178.118 98.7201 172.454C97.3986 170.733 94.6343 170.195 94.3343 169.837C91.87 166.867 88.4737 172.346 85.8626 178.042C84.8284 177.997 83.7942 178.189 82.8366 178.579L82.3642 166.938H37.5418L18.1216 198.707L39.0421 216.454C46.7412 224.57 54.1276 229.146 61.2968 230.688C66.0913 231.718 71.473 231.45 76.5866 230.253L90.4911 240.576C93.7022 242.957 98.2349 242.285 100.61 239.066L120.93 211.552C123.305 208.333 122.635 203.789 119.424 201.408Z"
      class="fill-brand-100"
    />
    <path
      d="M46.3265 236.973L9.34375 136.922H90.8807L53.898 236.973C52.5956 240.499 47.6224 240.499 46.3201 236.973H46.3265Z"
      class="fill-secondary-500"
    />
    <path
      d="M50.1186 82.1696C28.8342 82.1696 11.5781 99.4688 11.5781 120.806C11.5781 126.56 12.8422 132.019 15.0957 136.922H85.1414C87.395 132.013 88.659 126.56 88.659 120.806C88.659 99.4688 71.403 82.1696 50.1186 82.1696Z"
      class="fill-brand-100"
    />
    <path
      d="M32.3965 187.021L31.0686 186.406C31.6687 185.728 32.1794 184.96 32.5816 184.096C34.7649 179.36 32.7093 173.747 27.9851 171.558L25.3995 170.362C25.9358 169.728 26.4018 169.018 26.7657 168.23C28.9491 163.494 26.8934 157.882 22.1692 155.693L18.4856 153.984C13.7614 151.795 8.16264 153.856 5.9793 158.592C3.79596 163.328 5.85162 168.941 10.5758 171.13L13.1613 172.326C12.6251 172.96 12.159 173.67 11.7952 174.458C9.61182 179.194 11.6675 184.806 16.3917 186.995L18.358 187.91C17.9175 188.461 17.5216 189.069 17.2152 189.741C15.1659 194.182 17.0939 199.443 21.5244 201.498L24.9782 203.098C29.4087 205.152 34.6564 203.213 36.7057 198.778C38.755 194.336 36.8206 189.075 32.3965 187.021Z"
      class="fill-brand-100"
    />
    <path
      d="M78.0791 236.375L111.743 190.8L128.428 203.186C130.978 205.078 131.516 208.695 129.628 211.251L102.809 247.558C100.921 250.114 97.3135 250.654 94.7636 248.761L78.0791 236.375Z"
      class="fill-brand-500"
    />
    <path
      d="M77.1573 145.335C73.9069 141.247 67.9662 140.575 63.8886 143.834C59.811 147.092 59.1404 153.048 62.3909 157.136L84.0905 184.425C87.341 188.513 93.2816 189.185 97.3592 185.927C101.437 182.668 102.107 176.713 98.8569 172.625L77.1573 145.335Z"
      class="fill-brand-100"
    />
    <path
      d="M200.769 101.216H134.343C130.966 106.963 129.019 113.651 129.019 120.806C129.019 126.56 130.283 132.019 132.537 136.922H202.582C204.836 132.013 206.1 126.56 206.1 120.806C206.1 113.658 204.153 106.963 200.776 101.216H200.769Z"
      class="fill-brand-300"
    />
  </svg>
</template>

<script>
  export default {
    name: 'MoneyLeftEachMOnth'
  }
</script>
